<div class="container">
	<h2>Connecter Calaotrade à ...</h2>

	<ng-container *ngIf="canInteropMicrosoftMailbox || canInteropMicrosoftCalendar">
		<div class="container-title-system-id">
			<h3>
				<ion-icon src="assets/img/microsoft-M-logo.svg"></ion-icon>
				Microsoft
			</h3>
			<ion-note>
				<ng-container *ngIf="getDisplayNameBySystemId(interopSystem.microsoft) as displayName">
					{{displayName}} <br>
				</ng-container>
				{{getEmailBySystemId(interopSystem.microsoft)}}
			</ion-note>
		</div>

		<div>
			<ng-container *ngIf="canInteropMicrosoftMailbox">
				<ng-container *ngTemplateOutlet="mailbox; context: {systemId: interopSystem.microsoft}"></ng-container>
			</ng-container>

			<ng-container *ngIf="canInteropMicrosoftCalendar">
				<ng-container *ngTemplateOutlet="calendar; context: {systemId: interopSystem.microsoft}"></ng-container>
			</ng-container>
		</div>


		<div class="buttons">
			<ion-button shape="round" (click)="onApplyButtonClick(interopSystem.microsoft)"
				*ngIf="!(observableIsLoading.value$|async)">Appliquer</ion-button>
			<ion-spinner *ngIf="(observableIsLoading.value$|async)" color="primary"></ion-spinner>
		</div>
	</ng-container>

	<ng-container *ngIf="canInteropGoogleMailbox || canInteropGoogleCalendar">
		<div class="container-title-system-id">
			<h3>
				<ion-icon src="assets/img/google-G-logo.svg"> </ion-icon>
				Google
			</h3>
			<ion-note>
				<ng-container *ngIf="getDisplayNameBySystemId(interopSystem.google) as displayName">
					{{displayName}} <br>
				</ng-container>
				{{getEmailBySystemId(interopSystem.google)}}
			</ion-note>
		</div>

		<div>
			<ng-container *ngIf="canInteropGoogleMailbox">
				<ng-container *ngTemplateOutlet="mailbox; context: {systemId: interopSystem.google}"></ng-container>
			</ng-container>

			<ng-container *ngIf="canInteropGoogleCalendar">
				<ng-container *ngTemplateOutlet="calendar; context: {systemId: interopSystem.google}"></ng-container>
			</ng-container>
		</div>

		<div class="buttons">
			<ion-button shape="round" (click)="onApplyButtonClick(interopSystem.google)"
				*ngIf="!(observableIsLoading.value$|async)">Appliquer</ion-button>
			<ion-spinner *ngIf="(observableIsLoading.value$|async)" color="primary"></ion-spinner>
		</div>
	</ng-container>

	<div class="buttons">
		<ion-button fill="clear" color="medium" shape="round" (click)="close()">
			Fermer
		</ion-button>
	</div>
</div>

<ng-template #loading>
	<div>
		<ion-spinner color="primary"></ion-spinner>
	</div>
</ng-template>

<ng-template #mailbox let-systemId="systemId">
	<div class="container-service-type">
		<ion-toggle [enableOnOffLabels]="true" [checked]="hasSubscribe$(systemId,'mailbox')|async"
			(ionChange)="onToggleChanged(systemId,'mailbox',$event.detail.checked)"></ion-toggle>
		<ion-icon name="mail-sharp"></ion-icon>
		Messagerie
		<ng-container
			*ngTemplateOutlet="(hasSubscribe$(systemId, 'mailbox') | async)? connectedIcon : disconnectedIcon"></ng-container>
	</div>
</ng-template>

<ng-template #calendar let-systemId="systemId">
	<div class="container-service-type">
		<ion-toggle [enableOnOffLabels]="true" [checked]="hasSubscribe$(systemId,'calendar')|async"
			(ionChange)="onToggleChanged(systemId,'calendar',$event.detail.checked)"></ion-toggle>
		<ion-icon name="Calendar"></ion-icon>
		Calendrier
		<ng-container
			*ngTemplateOutlet="(hasSubscribe$(systemId, 'calendar') | async)? connectedIcon : disconnectedIcon"></ng-container>
	</div>
</ng-template>

<ng-template #connectedIcon>
	<ion-icon src="assets/img/linked.svg" class="connected"></ion-icon>
</ng-template>

<ng-template #disconnectedIcon>
	<ion-icon src="assets/img/unlinked.svg" class="disconnected"></ion-icon>
</ng-template>